<pr-modal-confirm
  #invalidIbanModal
  [title]="'IBAN non valide'"
  [comment]="
    'L\'IBAN que vous avez saisi ne semble pas conforme. Voulez-vous quand même l\'ajouter ?'
  "
  [labelConfirm]="'Confirmer'"
  [labelCancel]="'Corriger'"
  (onConfirm)="onConfirmInvalidIban()"
  (onConfirmOptionnal)="onCancelInvalidIban()"
  display="warning"
>
</pr-modal-confirm>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formGroupName="scpiRentPaymentIban">
      <debit [control]="'scpiRentPaymentIban'" [derrors]="derrors"></debit>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
